/* eslint-disable */
import axios from 'axios';
import { Vue } from "vue-property-decorator";
import { EndPoint } from './config';
export abstract class RestService extends Vue {

    private authorization = localStorage.getItem('token');
    private headers = {
        'content-type': 'application/json',
        'Authorization': this.authorization,
    }
    protected get(RelativeUrl: string) {
        return axios.get(EndPoint.API_URL + RelativeUrl, { headers: this.headers })
            .catch(err => {
                this.$toasted.global.throw({
                    message: err,
                });
            });
    }

    protected post(RelativeUrl: string, Data: any) {
        return axios.post(EndPoint.API_URL + RelativeUrl, Data)
            .catch(err => {
                this.$toasted.global.throw({
                    message: err,
                });
            });
    }

    protected delete(RelativeUrl: string) {
        return axios.delete(EndPoint.API_URL + RelativeUrl, { headers: this.headers })
            .catch(err => {
                this.$toasted.global.throw({
                    message: err,
                });
            });
    }
}